import React from 'react';
import { Button, Typography } from '@mui/material';

const FarmBoundaryEditor = ({ 
    farmArea, 
    selectedFeature, 
    isEditingFarm, 
    setIsEditingFarm, 
    setMode, 
    handleSaveFarm, 
    mode, 
    setSelectedFeature 
}) => {
    return (
        <div style={{ marginTop: '1rem' }}>
            <Typography variant="body1">
                Farm Area: {farmArea.toFixed(2)} hectares
            </Typography>
            
            {selectedFeature && (
                <Typography variant="body2" color="textSecondary" style={{ marginTop: '0.5rem' }}>
                    Selected Feature ID: {selectedFeature.id}
                </Typography>
            )}

            <div style={{ marginTop: '1rem' }}>
                <Button 
                    variant={isEditingFarm ? 'contained' : 'outlined'} 
                    color={isEditingFarm ? 'secondary' : 'primary'}
                    onClick={() => {
                        if (isEditingFarm) {
                            handleSaveFarm(selectedFeature);
                        } else {
                            setIsEditingFarm(true);
                            setMode('edit_farm');
                        }
                    }}
                    style={{ marginRight: '0.5rem', marginBottom: '0.5rem' }}
                >
                    {isEditingFarm ? 'Stop Editing & Save' : 'Edit Farm Boundary'}
                </Button>
                <Button 
                    variant={mode === 'draw_stand' ? 'contained' : 'outlined'} 
                    color={mode === 'draw_stand' ? 'secondary' : 'primary'}
                    onClick={() => {
                        const newMode = mode === 'draw_stand' ? 'view' : 'draw_stand';
                        setMode(newMode);
                        setIsEditingFarm(false);
                        if (newMode === 'view') setSelectedFeature(null);
                    }}
                    style={{ marginBottom: '0.5rem' }}
                >
                    {mode === 'draw_stand' ? 'Stop Drawing Stand' : 'Draw Forest Stand'}
                </Button>
            </div>
        </div>
    );
};

export default FarmBoundaryEditor;
